import type {WritableComputedRef} from 'vue';
import {useRouteParams} from '@vueuse/router';
import {compact} from 'lodash-es';
import type {RouteLocationNormalizedLoaded} from 'vue-router';
import {arrayify} from '~/utils';

export default function useVariadicRouteParam(name: string, route?: RouteLocationNormalizedLoaded): WritableComputedRef<string[]> {
	const params = useRouteParams(name, undefined, {route}) as WritableComputedRef<string | string[] | undefined>;

	return computed({
		get(): string[] {
			return compact(arrayify(params.value));
		},
		set(value: string[]) {
			params.value = value;
		},
	});
}
